import { Observable, Subscription, Subject } from 'rxjs/Rx'
import { ITimer, TimerService } from '..'

export class Countdown implements ITimer {
  private _timeUpdate: Subject<void>
  private _timeOut: Subject<void>
  private _timerSubscriptions: Subscription[] = []
  private _interval: number

  public constructor(
    private _allottedTime: number,
    private _timer: TimerService
  ) {
    this._interval = 1000
    this._timeUpdate = new Subject<void>()
    this._timeOut = new Subject<void>()
  }

  public get timeOut(): Observable<void> {
    return this._timeOut
  }

  public get timeUpdate(): Observable<void> {
    return this._timeUpdate
  }

  public get elapsedTime() {
    return this._timer.elapsedTime
  }

  public get currentTime() {
    return this._calculateRemainingTime()
  }

  public pause() {
    this._clearTimerSubscriptions()
    this._timer.pause()
  }

  public start() {
    this._timer.start()
    this._clearTimerSubscriptions()
    const timeoutOffset = 5
    const remainingTimeInMs = (this._calculateRemainingTime() * 1000) + timeoutOffset
    const endTimer = Observable.timer(remainingTimeInMs)
    this._timerSubscriptions.push(
      Observable.timer(this._interval, this._interval)
        .takeWhile(() => this._calculateRemainingTime() > 0)
        .subscribe(() => {
          this._timer.tick()
          this._timeUpdate.next()
        })
    )
    this._timerSubscriptions.push(
      endTimer.subscribe(() => {
        this._timeOut.next()
      })
    )
  }

  private _calculateRemainingTime() {
    return this._allottedTime - this._timer.elapsedTime
  }

  private _clearTimerSubscriptions() {
    this._timerSubscriptions.forEach((subscription) => subscription.unsubscribe())
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/timers/countdown/countdown.ts